import React from "react";

const Select = ({
  placeholder,
  field,
  name,
  onChange,
  options,
  id,
  label,
  errorMessage = "*This field is required"
}) => {
  return (
    <div className="form__wrapper">
      {label && (
        <label htmlFor={id} className="form__label">
          {label}
        </label>
      )}

      <select
        className={`form__input form__input--select ${
          field.showError ? "form__input--error" : ""
        } ${!field.value ? "form__input--default" : ""}`}
        id={id}
        value={field.value}
        name={name}
        onChange={evt => onChange(evt.currentTarget.value, name)}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((opt, index) => (
          <option key={`${name}_option_${index}`} value={opt.abbr}>
            {opt.name}
          </option>
        ))}
      </select>

      {field.showError && (
        <p className="form__copy form__copy--error">{errorMessage}</p>
      )}
    </div>
  );
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/_common/Form/inputs/Select.js